import { render } from "./ObraShow.vue?vue&type=template&id=19c51099"
import script from "./ObraShow.vue?vue&type=script&lang=js"
export * from "./ObraShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__